import { useCallback } from 'react';
import { UnicodeEntity } from '@mews/enums';
import { ProductOrder } from '../../transformProductOrders/types';
import { BillLink } from '../../../../components';
import { ItemsTableCellElement } from './styles';
import { CancelButton } from './CancelButton';

export const ProductOrderBillCancelCell: React.FC<ProductOrderBillCancelCellProps> = ({
    cancelProductOrder,
    order: { id, billId, isCanceled },
    groupId,
}) => {
    const handleCancel = useCallback(() => {
        cancelProductOrder(id);
    }, [cancelProductOrder, id]);

    const billLink =
        billId && !id ? (
            <BillLink billId={billId} groupId={groupId} />
        ) : (
            <BillLink orderItemId={id} groupId={groupId} />
        );

    return (
        <>
            <ItemsTableCellElement>{isCanceled ? UnicodeEntity.Dash : billLink}</ItemsTableCellElement>
            <ItemsTableCellElement>
                <CancelButton isCancelled={isCanceled} handleCancel={handleCancel} />
            </ItemsTableCellElement>
        </>
    );
};

interface ProductOrderBillCancelCellProps {
    cancelProductOrder: (id: string) => void;
    order: ProductOrder;
    groupId: string;
    accountId: string;
}
